<div class="zoom-image-container">
    <div class="zoom-image-container2">
        <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
            <span class="icon-view-close" aria-hidden="true">
                <svg>
                    <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
                </svg>
            </span>
            <span>{{ 'generic.close' | translate }}</span>
        </button>
        <img [src]="imgSrc" />
    </div>
</div>
<footer class="mt-4 text-center">
    <ng-hbm-bdi-btn class="light-grey" [loading]="dlLoading" (click)="download()" label="Télécharger"></ng-hbm-bdi-btn>
    <ng-hbm-bdi-btn class="light-grey" [loading]="printLoading" (click)="print()" label="Imprimer"></ng-hbm-bdi-btn>
</footer>

